/*import React from 'react'
import classes from './RnDOffer.module.css'

const RnDOffer = ({offerTitle, offerImage, altImg, offerArr}) => {
  return (
    <div className={classes['offer-box']}>
        <h3>{offerTitle}</h3>
        <img src={offerImage} alt={altImg} className={classes.image} />
        <ul className={classes.offerlists}>
            {offerArr.map((offer, i) => (
              <li key={i}>{offer}</li>
            ))}
        </ul>
    </div>
  )
}

export default RnDOffer*/




import React from "react";
import classes from "./RnDOffer.module.css";

const RnDOffer = ({ offerTitle, offerImage, altImg, offerArr, ctaText }) => {
  return (
    <article className={classes.offerCard} aria-label={offerTitle}>
      <img
        src={offerImage}
        alt={altImg}
        className={classes.offerImage}
        loading="lazy"
      />

      <h3 className={classes.offerTitle}>{offerTitle}</h3>

      <ul className={classes.offerList}>
        {offerArr.map((item, index) => (
          <li key={index}>{item}</li>
        ))}
      </ul>

      {ctaText && (
        <button className={classes.ctaButton} aria-label={ctaText}>
          {ctaText}
        </button>
      )}
    </article>
  );
};

export default RnDOffer;
